<script>
import { storeName } from "@/global/variable";
import { mapGetters, mapMutations } from "vuex";
import BottomCard from "./card/bottomCard.vue";

export default {
  name: "BottomBoard",
  components: { BottomCard },
  data() {
    return {
      tableInfo: {
        header: [
          "No",
          "거래타입",
          "상태",
          "코인가격",
          "코인수량",
          "사용/사용예정 USDT",
        ],
      },
    };
  },
  methods: {
    ...mapMutations(storeName.bs, ["MU_BS_SELECT"]),
    /* 이미지 불러오기 */
    getIconPath(iconAddress) {
      return require(`../assets/${iconAddress}`);
    },
    /* 코인 선택시 */
    selectCoin(index) {
      this.MU_BS_SELECT(index);
    },
    /* 칼럼 이름 파싱 */
  },
  computed: {
    ...mapGetters(storeName.core, ["GT_IS_LONG"]),
    ...mapGetters(storeName.asset, ["ASSET_CONFIG"]),
    ...mapGetters(storeName.buyConfig, [
      "GT_LONG_BUY_CONFIGS",
      "GT_SHORT_BUY_CONFIGS",
    ]),
    ...mapGetters(storeName.bs, ["GT_BS_CURRENT_COIN", "GT_BS_LIST"]),

    tableItems: function () {
      const allConfigs = this.GT_IS_LONG
        ? this.GT_LONG_BUY_CONFIGS
        : this.GT_SHORT_BUY_CONFIGS;

      const targetConfig = allConfigs[this.GT_BS_CURRENT_COIN.coinNameUSDT];
      console.log(targetConfig);

      return {
        config: targetConfig.config,
        init:
          targetConfig.list?.filter((f) => f.itemType === "INIT")[0] ?? null,
        list: targetConfig.list?.filter((f) => f.itemType !== "INIT"),
        force: targetConfig.force ?? null,
        profit: targetConfig.profit ?? null,
      };
    },

    symbolConfig: function () {
      return this.ASSET_CONFIG(this.GT_BS_CURRENT_COIN.coinNameUSDT);
    },
  },
};
</script>
<template>
  <div class="mt-4 pt-4 border-t">
    <!-- bottom board header (select coin , filter items) -->
    <div>
      <ul class="flex gap-x-4">
        <li
          v-for="(sb, index) in GT_BS_LIST"
          :key="sb"
          class="pr-1 cursor-pointer"
          :class="{
            'opacity-50': index !== GT_BS_CURRENT_COIN.selectedIndex,
            'opacity-100, font-semibold':
              index === GT_BS_CURRENT_COIN.selectedIndex,
          }"
          @click="selectCoin(index)"
        >
          <img :src="getIconPath(sb.icon)" class="w-6 h-6 inline-block mr-2" />
          <span>{{ sb.name }}</span>
        </li>
      </ul>
    </div>
    <!-- bottom board items -->
    <div class="pt-2">
      <!-- tab items -->
      <!-- <div></div> -->
      <div class="relative">
        <div class="bottom-board-wrap">
          <div class="bottom-board-div">
            <div class="bottom-board-card position-init">
              <p class="bottom-board-card-header">포지션 진입</p>
              <BottomCard
                :symbolConfig="symbolConfig"
                :item="tableItems.init"
                :type="'init'"
                :retryForceMin="
                  tableItems.config?.prevForceFlag
                    ? tableItems.config?.retryForceMin
                    : tableItems.config?.retryLiqMin
                "
                :curCoinName="GT_BS_CURRENT_COIN.coinName"
              />
            </div>
          </div>
          <div class="bottom-board-div">
            <div class="bottom-board-card position-add">
              <p class="bottom-board-card-header">
                물타기
                {{
                  tableItems && tableItems.config != null
                    ? tableItems.config.addBuyLimit == 0
                      ? "( 무제한 )"
                      : tableItems.list.length +
                        "/" +
                        tableItems.config.addBuyLimit +
                        "단계"
                    : ""
                }}
              </p>

              <BottomCard
                :symbolConfig="symbolConfig"
                v-for="(addBuy, index) in tableItems.list"
                :key="addBuy"
                :item="addBuy"
                :step="index"
                :type="'add'"
                :retryForceMin="tableItems.config?.retryForceMin"
                :curCoinName="GT_BS_CURRENT_COIN.coinName"
              />
            </div>
          </div>
          <div class="bottom-board-div">
            <div class="bottom-board-card position-sell">
              <p class="bottom-board-card-header">손/익절</p>
              <BottomCard
                :symbolConfig="symbolConfig"
                :item="tableItems.force"
                :type="'sellf'"
                :retryForceMin="tableItems.config?.retryForceMin"
                :curCoinName="GT_BS_CURRENT_COIN.coinName"
              />
              <BottomCard
                :symbolConfig="symbolConfig"
                :item="tableItems.profit"
                :type="'sellp'"
                :retryForceMin="tableItems.config?.retryForceMin"
                :curCoinName="GT_BS_CURRENT_COIN.coinName"
              />
            </div>
          </div>
        </div>

        <div
          v-if="tableItems?.config && tableItems?.config?.isEndTrade == 1"
          class="tradeStopFixed"
        >
          <p>종료된 거래입니다</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style scope>
.tradeStopFixed {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000a9;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: #ffffff;
}
</style>
